import React from 'react';
import {
  Box,
  Slider,
  Typography,
  IconButton,
  Avatar,
  Stack,
  Container
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Replay10Icon from '@mui/icons-material/Replay10';
import Forward30Icon from '@mui/icons-material/Forward30';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import TuneIcon from '@mui/icons-material/Tune';

const Player = () => (
  <Box
    sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      bgcolor: '#1e1e1e',
      color: '#fff',
      boxShadow: 4,
      zIndex: 1300,
    }}
  >
    <Container maxWidth={false} sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      {/* 왼쪽: 썸네일 + 제목 */}
      <Stack direction="row" spacing={2} alignItems="center" sx={{ minWidth: 220 }}>
        <Avatar sx={{ bgcolor: 'grey.700' }} variant="rounded" />
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">
            뭘 들을까?
          </Typography>
          <Typography variant="caption" color="gray">
            클루비
          </Typography>
        </Box>
      </Stack>

      {/* 중앙: 재생 컨트롤 */}
      <Stack direction="row" spacing={2} alignItems="center" flex={1} justifyContent="center">
        <IconButton><Replay10Icon sx={{ color: 'gray' }} fontSize="small" /></IconButton>
        <IconButton><PlayArrowIcon sx={{ color: 'white' }} fontSize="large" /></IconButton>
        <IconButton><Forward30Icon sx={{ color: 'gray' }} fontSize="small" /></IconButton>
        <Typography variant="caption" sx={{ ml: 1 }}>
          0:00:00 / 0:00:00
        </Typography>
      </Stack>

      {/* 오른쪽: 볼륨 & 배속 */}
      <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 200 }}>
        <Slider defaultValue={50} sx={{ color: 'white', width: 100 }} />
        <VolumeUpIcon sx={{ color: 'white' }} />
        <Box
          sx={{
            bgcolor: '#2e2e2e',
            px: 1,
            py: 0.3,
            borderRadius: 1,
            fontSize: '0.75rem',
            fontWeight: 'bold',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          1.0x
        </Box>
        <TuneIcon sx={{ color: 'white' }} fontSize="small" />
      </Stack>
    </Container>
  </Box>
);

export default Player;
